<sxw-side-dialog
  [backOnClose]="false"
  [visible]="visible"
  (visibleChange)="handleVisibleChange($event)"
  (onHideDialog)="toggleAddPaymentMethodView(false)"
  theme="sxw-popup-cards"
>
  <h2>
    {{
      (showAddPaymentMethodView
        ? paymentFormTitle
        : "paymentMethod.selectTitle"
      ) | translate
    }}
  </h2>

  <app-payment-methods-list
    *ngIf="!showAddPaymentMethodView"
    [ngModel]="value"
    (ngModelChange)="writeValue($event); onChange($event)"
    [paymentMethods]="paymentMethods"
  ></app-payment-methods-list>

  <app-add-payment-method-form
    *ngIf="showAddPaymentMethodView && setupClientSecret"
    [defaultBillingInfo]="defaultBillingInfo"
    [clientSecret]="setupClientSecret"
    (afterSubmitSuccess)="handleSavePaymentMethod($event)"
  ></app-add-payment-method-form>

  <button
    *ngIf="!showAddPaymentMethodView"
    class="subscribe-button"
    (click)="submit(value!)"
    [disabled]="!value || submitDisabled"
  >
    {{ submitLabel | translate }}
  </button>

  <a
    *ngIf="
      setupClientSecretObservable &&
      (!showAddPaymentMethodView || paymentMethods.length)
    "
    class="link add-payment-link"
    (click)="toggleAddPaymentMethodView()"
  >
    {{
      (showAddPaymentMethodView
        ? "paymentMethod.buttons.backToPaymentMethodsList"
        : openPaymentFormLinkLabel
      ) | translate
    }}
  </a>
</sxw-side-dialog>
